import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { APP_MODULES } from 'const';
import { Button } from 'components/ui';
import { INVOICE_SEARCH_TRANSLATIONS } from 'const/translations';
import { selectUserAuthorizedModules } from 'modules/loggedUserInfo/selectors';
import { MODAL_TYPES } from 'const/ModalContainer';
import { openModal } from 'modules/ModalContainer/actions';
import Styles from 'containers/InvoiceSearchPage/InvoiceSearch.module.css';

const { BUTTONS } = INVOICE_SEARCH_TRANSLATIONS;

const propTypes = {
  selectedAcceptableInvoicesKeys: PropTypes.array,
  setSelectedAcceptableInvoicesKeys: PropTypes.func,
  selectedRowKeys: PropTypes.array,
  setSelectedRowKeys: PropTypes.func,
  canHaveSelections: PropTypes.bool,
};

export const MassActionsButtons = ({
  selectedAcceptableInvoicesKeys,
  setSelectedAcceptableInvoicesKeys,
  selectedRowKeys,
  setSelectedRowKeys,
  canHaveSelections,
}) => {
  const dispatch = useDispatch();

  const currentPackages = useSelector(selectUserAuthorizedModules);

  const onSuccess = useCallback(() => {
    setSelectedAcceptableInvoicesKeys([]);
    setSelectedRowKeys([]);
  }, [setSelectedAcceptableInvoicesKeys, setSelectedRowKeys]);

  const handleMassActionsModalOpen = (
    paidOutside = false,
    isMassPaidComplete = false
  ) => {
    dispatch(
      openModal({
        type: MODAL_TYPES.massInvoiceActionsModal,
        modalProps: {
          selectedRowKeys,
          selectedAcceptableInvoicesKeys,
          setSelectedRowKeys,
          paidOutside,
          isMassPaidComplete,
          onSuccess,
        },
      })
    );
  };
  const handleMassActionsPaidOutside = () => handleMassActionsModalOpen(true);
  const handleMassActionsNotValidated = () => handleMassActionsModalOpen();
  const handleMassActionsPaidComplete = () =>
    handleMassActionsModalOpen(false, true);

  return (
    <>
      {canHaveSelections && (
        <>
          <Button
            disabled={!selectedRowKeys?.length}
            outlined
            variant="secondary"
            className={Styles.massActionButton}
            big
            onClick={handleMassActionsPaidOutside}
          >
            {BUTTONS.PAID_OUTSIDE}
          </Button>
          <Button
            disabled={!selectedRowKeys?.length}
            outlined
            variant="secondary"
            className={Styles.massActionButton}
            big
            onClick={handleMassActionsNotValidated}
          >
            {BUTTONS.APPROVE}
          </Button>
        </>
      )}
      {currentPackages.includes(APP_MODULES.PAY_INVOICE) && (
        <Button
          disabled={!selectedAcceptableInvoicesKeys?.length}
          outlined
          variant="secondary"
          className={Styles.massActionButton}
          big
          onClick={handleMassActionsPaidComplete}
        >
          {BUTTONS.ACCEPT}
        </Button>
      )}
    </>
  );
};

MassActionsButtons.propTypes = propTypes;
